import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Unified alarm shape returned for wind, solar, and storage. */
export type Alarm = {
  __typename?: 'ALARM';
  DEVICE?: Maybe<Device>;
  _id: Scalars['ID']['output'];
  _id_asset: Scalars['ID']['output'];
  _id_assetTech: Scalars['ID']['output'];
  _id_subasset?: Maybe<Scalars['ID']['output']>;
  alarmType: AlarmTypeEnum;
  category?: Maybe<AlarmCategoryEnum>;
  code?: Maybe<Scalars['String']['output']>;
  /** Present for CUSTOM alarms. Null for STANDARD and WIND. */
  customCategory?: Maybe<CustomCategory>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endTS?: Maybe<Scalars['Float']['output']>;
  isAcknowledged: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  productionLoss?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<AlarmSeverityEnum>;
  startTS?: Maybe<Scalars['Float']['output']>;
  type: AlarmTechnologyEnum;
};

/** Alarm capability container exposed from PORTFOLIO and ASSET scopes. */
export type Alx = {
  __typename?: 'ALX';
  alarms: AlarmListResult;
  alarmsByTechnology: AlarmsByTechnologyResult;
  /**
   * Solar and storage custom categories for this ALX scope. Empty for wind-only scopes.
   * type limits the catalog to one technology; omit to return both.
   */
  customCategories: Array<CustomCategory>;
};


/** Alarm capability container exposed from PORTFOLIO and ASSET scopes. */
export type AlxAlarmsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AlarmOrderByInput>;
  where?: InputMaybe<AlarmWhereInput>;
};


/** Alarm capability container exposed from PORTFOLIO and ASSET scopes. */
export type AlxAlarmsByTechnologyArgs = {
  where?: InputMaybe<AlarmWhereInput>;
};


/** Alarm capability container exposed from PORTFOLIO and ASSET scopes. */
export type AlxCustomCategoriesArgs = {
  type?: InputMaybe<AlarmTechnologyEnum>;
};

export type Assest = {
  __typename?: 'ASSEST';
  _id?: Maybe<Scalars['String']['output']>;
  _id_country?: Maybe<Scalars['String']['output']>;
  _id_portfolio?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export type Assests_Available = {
  __typename?: 'ASSESTS_AVAILABLE';
  solar?: Maybe<Array<Maybe<Assest>>>;
  storage?: Maybe<Array<Maybe<Assest>>>;
  wind?: Maybe<Array<Maybe<Assest>>>;
};

export type Asset = {
  __typename?: 'ASSET';
  ALX?: Maybe<Alx>;
  COUNTRY: Country;
  DATA?: Maybe<Data>;
  PORTFOLIO: Portfolio_Metadata;
  SOLAR?: Maybe<Asset_Tech>;
  STORAGE?: Maybe<Asset_Tech>;
  SUBASSETS: Array<Subasset>;
  WIND?: Maybe<Asset_Tech>;
  _id: Scalars['ID']['output'];
  _id_country?: Maybe<Scalars['ID']['output']>;
  _id_portfolio: Scalars['ID']['output'];
  code?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  isCompleteSubassetSelection?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfSubassets?: Maybe<Scalars['Int']['output']>;
  poiLimit?: Maybe<Scalars['Float']['output']>;
  ratedPower?: Maybe<Scalars['Float']['output']>;
  subassetIdsFilter?: Maybe<Array<Scalars['String']['output']>>;
};


export type AssetSubassetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SubassetSortInput>;
};

export type AssetSortInput = {
  _id_country?: InputMaybe<Sort>;
  _id_portfolio?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  displayName?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lon?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  ratedPower?: InputMaybe<Sort>;
};

export type AssetWhereInput = {
  AND?: InputMaybe<Array<AssetWhereInput>>;
  OR?: InputMaybe<Array<AssetWhereInput>>;
  _id_country?: InputMaybe<StringInput>;
  _id_portfolio?: InputMaybe<StringInput>;
  code?: InputMaybe<StringInput>;
  displayName?: InputMaybe<StringInput>;
  lat?: InputMaybe<FloatInput>;
  lon?: InputMaybe<FloatInput>;
  name?: InputMaybe<StringInput>;
  ratedPower?: InputMaybe<FloatInput>;
};

export type Asset_Tech = {
  __typename?: 'ASSET_TECH';
  TECHNOLOGY: Technology;
  _id?: Maybe<Scalars['ID']['output']>;
  _id_technology?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dataDelay?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  poiLimit?: Maybe<Scalars['Float']['output']>;
  ratedPower?: Maybe<Scalars['Float']['output']>;
};

export type Attributes = {
  __typename?: 'ATTRIBUTES';
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  internal_user?: Maybe<Scalars['String']['output']>;
  is_portfolio_admin?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managed_by?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  solar_report_write?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum AlarmCategoryEnum {
  InService = 'IN_SERVICE',
  Limited = 'LIMITED',
  LowIrradiance = 'LOW_IRRADIANCE',
  Nocturne = 'NOCTURNE',
  NoData = 'NO_DATA',
  SafetyWarning = 'SAFETY_WARNING',
  Stop = 'STOP',
  Underperformance = 'UNDERPERFORMANCE'
}

export enum AlarmLevelEnum {
  AssetTech = 'ASSET_TECH',
  Subasset = 'SUBASSET'
}

/** Flat alarm list with shared pagination metadata. */
export type AlarmListResult = {
  __typename?: 'AlarmListResult';
  alarms: Array<Alarm>;
  totalCount: Scalars['Int']['output'];
};

export type AlarmOrderByInput = {
  alarmType?: InputMaybe<Sort>;
  /** Orders by the displayed category: standard category label or custom category name. */
  category?: InputMaybe<Sort>;
  /** Alphabetical order, empty codes are treated as null and sorted last. */
  code?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  endTS?: InputMaybe<Sort>;
  isAcknowledged?: InputMaybe<Sort>;
  isOpen?: InputMaybe<Sort>;
  productionLoss?: InputMaybe<Sort>;
  severity?: InputMaybe<Sort>;
  startTS?: InputMaybe<Sort>;
  type?: InputMaybe<Sort>;
};

export enum AlarmSeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum AlarmTechnologyEnum {
  Solar = 'SOLAR',
  Storage = 'STORAGE',
  Wind = 'WIND'
}

/** Closed search interval used to find alarms active at any point in the range. [startTS, endTS] */
export type AlarmTimeIntervalInput = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};

export enum AlarmTypeEnum {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

export type AlarmWhereInput = {
  alarmType?: InputMaybe<Array<AlarmTypeEnum>>;
  /** Filters STANDARD alarms by category. Does not affect CUSTOM alarms. Empty does not apply this filter. */
  category?: InputMaybe<Array<AlarmCategoryEnum>>;
  /** Filters solar and storage CUSTOM alarms by catalog id. Does not affect STANDARD. Empty does not apply this filter. */
  customCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters alarms by asset-tech or subasset level. An empty list does not apply any filter by level. */
  level?: InputMaybe<Array<AlarmLevelEnum>>;
  /** Returns alarms whose active period overlaps this search interval. */
  overlapsInterval?: InputMaybe<AlarmTimeIntervalInput>;
  severity?: InputMaybe<Array<AlarmSeverityEnum>>;
  type?: InputMaybe<Array<AlarmTechnologyEnum>>;
};

/** Alarm lists split by technology with the same shape as the flat list. */
export type AlarmsByTechnologyResult = {
  __typename?: 'AlarmsByTechnologyResult';
  SOLAR: AlarmListResult;
  STORAGE: AlarmListResult;
  WIND: AlarmListResult;
  totalCount: Scalars['Int']['output'];
};


/** Alarm lists split by technology with the same shape as the flat list. */
export type AlarmsByTechnologyResultSolarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AlarmOrderByInput>;
};


/** Alarm lists split by technology with the same shape as the flat list. */
export type AlarmsByTechnologyResultStorageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AlarmOrderByInput>;
};


/** Alarm lists split by technology with the same shape as the flat list. */
export type AlarmsByTechnologyResultWindArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AlarmOrderByInput>;
};

export type BooleanInput = {
  EQ?: InputMaybe<Scalars['Boolean']['input']>;
  NEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Country = {
  __typename?: 'COUNTRY';
  ASSETS: Array<Asset>;
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type CountryAssetsArgs = {
  inverters?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AssetSortInput>;
};

export type CountrySortInput = {
  _id?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  currency?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  _id?: InputMaybe<StringInput>;
  code?: InputMaybe<StringInput>;
  currency?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

export type CreateUserCustomPortfolio = {
  name?: InputMaybe<Scalars['String']['input']>;
  plants?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Portfolio-scoped solar or storage custom category. Wind has none. */
export type CustomCategory = {
  __typename?: 'CustomCategory';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: AlarmTechnologyEnum;
};

export type Data = {
  __typename?: 'DATA';
  SNAPSHOT?: Maybe<Snapshot>;
  TIMESERIES?: Maybe<Timeseries>;
  _id: Scalars['ID']['output'];
};


export type DataSnapshotArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type DataTimeseriesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Current device metadata. Devices are not restricted to navigation subassets. */
export type Device = {
  __typename?: 'DEVICE';
  TECHNOLOGY?: Maybe<Technology>;
  _id: Scalars['ID']['output'];
  _id_assetTech?: Maybe<Scalars['ID']['output']>;
  _id_technology?: Maybe<Scalars['ID']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
};

export type FloatInput = {
  EQ?: InputMaybe<Scalars['Float']['input']>;
  GT?: InputMaybe<Scalars['Float']['input']>;
  GTE?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  LT?: InputMaybe<Scalars['Float']['input']>;
  LTE?: InputMaybe<Scalars['Float']['input']>;
  NEQ?: InputMaybe<Scalars['Float']['input']>;
  NIN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum GroupByEnumSnapshot {
  Country = 'COUNTRY',
  Device = 'DEVICE'
}

export type IPoiLimit = {
  __typename?: 'IPoiLimit';
  solar?: Maybe<Scalars['Float']['output']>;
  storage?: Maybe<Scalars['Float']['output']>;
  wind?: Maybe<Scalars['Float']['output']>;
};

export type IntInput = {
  EQ?: InputMaybe<Scalars['Int']['input']>;
  GT?: InputMaybe<Scalars['Int']['input']>;
  GTE?: InputMaybe<Scalars['Int']['input']>;
  IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  LT?: InputMaybe<Scalars['Int']['input']>;
  LTE?: InputMaybe<Scalars['Int']['input']>;
  NEQ?: InputMaybe<Scalars['Int']['input']>;
  NIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCustomPortfolio: User_Portfolio;
  deleteUserCustomPortfolio: Scalars['String']['output'];
  removeConfiguredTopt: Scalars['Boolean']['output'];
  requestOtpConfigEmail: Scalars['Boolean']['output'];
  requestPasswordResetEmail: Scalars['Boolean']['output'];
  setDefaultCustomPortfolio: Scalars['String']['output'];
  updateLastLogin: Scalars['Boolean']['output'];
  updateUserCustomPortfolio: User_Portfolio;
};


export type MutationCreateCustomPortfolioArgs = {
  userPortfolio?: InputMaybe<CreateUserCustomPortfolio>;
};


export type MutationDeleteUserCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
};


export type MutationSetDefaultCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
};


export type MutationUpdateUserCustomPortfolioArgs = {
  userPortfolio?: InputMaybe<UpdateUserCustomPortfolioinput>;
};

export type Portfolio = {
  __typename?: 'PORTFOLIO';
  ALX?: Maybe<Alx>;
  ASSETS: Array<Asset>;
  DATA?: Maybe<Data>;
  _id: Scalars['ID']['output'];
  assetIdsFilter?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  numberOfAssets?: Maybe<Scalars['Int']['output']>;
  numberOfSites?: Maybe<Scalars['Int']['output']>;
  poiLimit?: Maybe<IPoiLimit>;
};


export type PortfolioAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AssetSortInput>;
  subassets?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Portfolio_Metadata = {
  __typename?: 'PORTFOLIO_METADATA';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unique_name: Scalars['String']['output'];
};

export type Portfolio_MetadataSortInput = {
  _id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  unique_name?: InputMaybe<Sort>;
};

export type Portfolio_MetadataWhereInput = {
  AND?: InputMaybe<Array<Portfolio_MetadataWhereInput>>;
  OR?: InputMaybe<Array<Portfolio_MetadataWhereInput>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  unique_name?: InputMaybe<StringInput>;
};

export type Power_Flow = {
  __typename?: 'POWER_FLOW';
  battery_to_grid?: Maybe<Scalars['Float']['output']>;
  deviation?: Maybe<Scalars['Float']['output']>;
  solar_to_battery?: Maybe<Scalars['Float']['output']>;
  solar_to_grid?: Maybe<Scalars['Float']['output']>;
  wind_to_battery?: Maybe<Scalars['Float']['output']>;
  wind_to_grid?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  ASSETS: Array<Asset>;
  COUNTRIES: Array<Country>;
  PORTFOLIO: Portfolio;
  PORTFOLIOS_METADATA: Array<Portfolio_Metadata>;
  SUBASSETS: Array<Subasset>;
  TECHNOLOGYS: Array<Technology>;
  USER: User;
};


export type QueryAssetsArgs = {
  _ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AssetSortInput>;
  subassets?: InputMaybe<Array<Scalars['ID']['input']>>;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryCountriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CountrySortInput>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryPortfolioArgs = {
  assets?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPortfolios_MetadataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Portfolio_MetadataSortInput>;
  where?: InputMaybe<Portfolio_MetadataWhereInput>;
};


export type QuerySubassetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SubassetSortInput>;
  where?: InputMaybe<SubassetWhereInput>;
};


export type QueryTechnologysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TechnologySortInput>;
  where?: InputMaybe<TechnologyWhereInput>;
};

export type Snapshot = {
  __typename?: 'SNAPSHOT';
  CHILDREN_SIGNAL?: Maybe<Array<Maybe<Snapshot_Result>>>;
  SIGNAL?: Maybe<Snapshot_Result>;
  availableSites?: Maybe<Scalars['Int']['output']>;
};


export type SnapshotChildren_SignalArgs = {
  groupBy?: InputMaybe<GroupByEnumSnapshot>;
};

export type SnapshotSortInput = {
  activePower?: InputMaybe<Sort>;
  displayName?: InputMaybe<Sort>;
  ts?: InputMaybe<Sort>;
};

export type Snapshot_Result = {
  __typename?: 'SNAPSHOT_RESULT';
  POWER_FLOW?: Maybe<Power_Flow>;
  SOLAR?: Maybe<Snapshot_Tech>;
  STORAGE?: Maybe<Snapshot_Tech>;
  WIND?: Maybe<Snapshot_Tech>;
  _id_country?: Maybe<Scalars['String']['output']>;
  /** Daily AC energy in kWh from recorded EAC signals. */
  acEnergy?: Maybe<Scalars['Float']['output']>;
  activePower?: Maybe<Scalars['Float']['output']>;
  availability?: Maybe<Scalars['Float']['output']>;
  availableDevices?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Wind/Solar expected-minus-actual energy plus native Storage energy loss, in kWh. */
  energyLoss?: Maybe<Scalars['Float']['output']>;
  expectedEnergy?: Maybe<Scalars['Float']['output']>;
  expectedPower?: Maybe<Scalars['Float']['output']>;
  gridPower?: Maybe<Scalars['Float']['output']>;
  /** Rated-power-weighted Performing OK fraction (0–1). Missing-data capacity stays in the denominator. No usable statuses, or zero/unknown total rated power, returns null. */
  performance?: Maybe<Scalars['Float']['output']>;
  powerLoss?: Maybe<Scalars['Float']['output']>;
  ratedPower?: Maybe<Scalars['Float']['output']>;
  setpoint?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  ts?: Maybe<Scalars['Float']['output']>;
};

export type Snapshot_Tech = {
  __typename?: 'SNAPSHOT_TECH';
  _id?: Maybe<Scalars['ID']['output']>;
  /** Daily AC energy in kWh from recorded EAC signals. */
  acEnergy?: Maybe<Scalars['Float']['output']>;
  activePower?: Maybe<Scalars['Float']['output']>;
  availability?: Maybe<Scalars['Float']['output']>;
  availableDevices?: Maybe<Scalars['Int']['output']>;
  /** Daily energy loss in kWh; Storage uses SUM(kpiStoredEnergy - eac). */
  energyLoss?: Maybe<Scalars['Float']['output']>;
  expectedEnergy?: Maybe<Scalars['Float']['output']>;
  expectedPower?: Maybe<Scalars['Float']['output']>;
  kpiStoredEnergy?: Maybe<Scalars['Float']['output']>;
  /** Performing OK fraction (0–1), weighted by site rated power within this technology. Missing-data capacity stays in the denominator. No usable statuses, or zero/unknown total rated power, returns null. */
  performance?: Maybe<Scalars['Float']['output']>;
  powerLoss?: Maybe<Scalars['Float']['output']>;
  ratedPower?: Maybe<Scalars['Float']['output']>;
  serialNav?: Maybe<Scalars['Float']['output']>;
  setpoint?: Maybe<Scalars['Float']['output']>;
  stOfCh?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  stoppedDevices?: Maybe<Scalars['Int']['output']>;
  ts?: Maybe<Scalars['Float']['output']>;
};

export type Subasset = {
  __typename?: 'SUBASSET';
  ASSET: Asset;
  DATA?: Maybe<Data>;
  TECHNOLOGY: Technology;
  _id: Scalars['ID']['output'];
  _id_asset: Scalars['ID']['output'];
  _id_technology?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeDisplay?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ratedPower?: Maybe<Scalars['Float']['output']>;
  serialNav?: Maybe<Scalars['Float']['output']>;
};

export type SubassetSortInput = {
  _id?: InputMaybe<Sort>;
  _id_asset?: InputMaybe<Sort>;
  _id_technology?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  codeDisplay?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lon?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  ratedPower?: InputMaybe<Sort>;
};

export type SubassetWhereInput = {
  AND?: InputMaybe<Array<SubassetWhereInput>>;
  OR?: InputMaybe<Array<SubassetWhereInput>>;
  _id?: InputMaybe<StringInput>;
  _id_asset?: InputMaybe<StringInput>;
  _id_technology?: InputMaybe<StringInput>;
  code?: InputMaybe<StringInput>;
  codeDisplay?: InputMaybe<StringInput>;
  lat?: InputMaybe<FloatInput>;
  lon?: InputMaybe<FloatInput>;
  name?: InputMaybe<StringInput>;
  ratedPower?: InputMaybe<FloatInput>;
  serialNav?: InputMaybe<FloatInput>;
};

export type SecurityPreferences = {
  __typename?: 'SecurityPreferences';
  isTotpEnabled: Scalars['Boolean']['output'];
};

export enum SignalSampling {
  Daily = 'DAILY',
  HalfHourly = 'HALF_HOURLY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  No = 'NO',
  QuarterHourly = 'QUARTER_HOURLY',
  TenMinutely = 'TEN_MINUTELY',
  Total = 'TOTAL',
  Weekly = 'WEEKLY'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringInput = {
  EQ?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Array<Scalars['String']['input']>>;
  NEQ?: InputMaybe<Scalars['String']['input']>;
  NIN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGEX?: InputMaybe<Scalars['String']['input']>;
};

export type Technology = {
  __typename?: 'TECHNOLOGY';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TechnologySortInput = {
  _id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type TechnologyWhereInput = {
  AND?: InputMaybe<Array<TechnologyWhereInput>>;
  OR?: InputMaybe<Array<TechnologyWhereInput>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

export type Timeseries = {
  __typename?: 'TIMESERIES';
  SIGNALS?: Maybe<Array<Maybe<Timeseries_Result>>>;
};


export type TimeseriesSignalsArgs = {
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Scalars['Boolean']['input']>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  perTechnology?: InputMaybe<Scalars['Boolean']['input']>;
  signals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  timeSampling?: InputMaybe<SignalSampling>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Timeseries_Result = {
  __typename?: 'TIMESERIES_RESULT';
  _id?: Maybe<Scalars['ID']['output']>;
  dataJSON?: Maybe<Array<Maybe<JsonMap>>>;
  dataJSONString?: Maybe<Array<Maybe<JsonMapString>>>;
  dataKeyValue?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  dataKeyValueString?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  dataTimestamp?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dataTimestampString?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataValue?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dataValueString?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endTS: Scalars['Float']['output'];
  interval: Scalars['Float']['output'];
  signalName?: Maybe<Scalars['String']['output']>;
  startTS: Scalars['Float']['output'];
  technology?: Maybe<TechnologyEnum>;
};

export enum TechnologyEnum {
  Solar = 'SOLAR',
  Storage = 'STORAGE',
  Wind = 'WIND'
}

export type User = {
  __typename?: 'USER';
  USER_PORTFOLIOS?: Maybe<Array<Maybe<User_Portfolio>>>;
  apps_available?: Maybe<Array<Scalars['String']['output']>>;
  assets_available?: Maybe<Assests_Available>;
  attributes?: Maybe<Attributes>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  modules_available?: Maybe<Array<Scalars['String']['output']>>;
  position?: Maybe<Scalars['String']['output']>;
  securityPreferences: SecurityPreferences;
  updated_at?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type User_Portfolio = {
  __typename?: 'USER_PORTFOLIO';
  PLANTS?: Maybe<Array<Maybe<Asset>>>;
  _id: Scalars['ID']['output'];
  defaultPortfolio: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  plants?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateUserCustomPortfolioinput = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  plants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JsonMap = {
  __typename?: 'jsonMap';
  timestamp?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type JsonMapString = {
  __typename?: 'jsonMapString';
  timestamp?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SiteTechnologyInfoQueryVariables = Exact<{
  subassets?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SiteTechnologyInfoQuery = { __typename?: 'Query', ASSETS: Array<{ __typename?: 'ASSET', _id: string, SOLAR?: { __typename?: 'ASSET_TECH', _id?: string | null } | null, WIND?: { __typename?: 'ASSET_TECH', _id?: string | null, name?: string | null } | null, STORAGE?: { __typename?: 'ASSET_TECH', _id?: string | null } | null }> };

export const SiteTechnologyInfoDocument = gql`
    query SiteTechnologyInfo($subassets: [ID!]) {
  ASSETS(subassets: $subassets) {
    _id
    SOLAR {
      _id
    }
    WIND {
      _id
      name
    }
    STORAGE {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteTechnologyInfoGQL extends Apollo.Query<SiteTechnologyInfoQuery, SiteTechnologyInfoQueryVariables> {
    document = SiteTechnologyInfoDocument;
    client = 'multitech-api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }